<h1 mat-dialog-title>Wartungsbericht Abscheider</h1>
<div mat-dialog-content>
  <app-form-wartungsbericht-abscheider
    [form]="form"
    [anlagenreihe]="auftrag.ANLAGENREIHE"
  ></app-form-wartungsbericht-abscheider>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]>Abbrechen</button>
  <button mat-button [mat-dialog-close]="form.dirty ? form.value : null" cdkFocusInitial>
    Speichern
  </button>
</div>
